module.exports = __webpack_public_path__ + "static/media/thumbnail-epuletbontas-rakoscsaba-ujtelep.88f12538.jpg";